// extracted by mini-css-extract-plugin
export default {"number":"Number_number__0+1xr","reverse":"Number_reverse__40DeI"};